import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { PrProfileContext } from "../../data/pr_profile_context_management";
import usePrRepresentationsApi from "../../data/use_pr_representations_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import AddCompanyInput from "./add_company_card/AddCompanyInput";

// The Add surface for represented companies. Only the picker lives here: removal happens inline on the
// page's RepresentsSection, so this body does not restate the represented list. A successful add
// requests the Companies tab and closes.
function CompaniesModalBody({ close }) {
  const context = useContext(PrProfileContext);
  const { representedCompanies, generalError, setActiveTabRequest } = context;
  const { addCompany } = usePrRepresentationsApi({ ...context });

  const excludedCompanyIds = (representedCompanies || []).map((company) => company.id);

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} />
        <div className="row g-2">
          <AddCompanyInput
            existingCompaniesIds={excludedCompanyIds}
            onSubmit={async (companyId) => {
              // Stay open on failure so the alert above is what the viewer sees, not a vanished modal.
              const { saved } = await addCompany(companyId);
              if (saved) {
                setActiveTabRequest("companies");
                close();
              }
            }}
            onCancel={close}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default CompaniesModalBody;
